/**
 * Defines an array of preconnect and preload links based on the VITE_ENTRY_POINT environment variable.
 *
 * If VITE_ENTRY_POINT is 'mcom', it includes preconnect to `slimages.macysassets.com`
 * and preload links for Macy's Sans fonts.
 * Otherwise (e.g., for Bloomingdale's), it includes a preconnect link to `images.bloomingdalesassets.com`.
 *
 * @type {Array<Object>}
 */
export default function headLinks() {
  const preconnectLinks = [];
  if (import.meta.env.VITE_ENTRY_POINT === 'mcom') {
    preconnectLinks.push({
      rel: 'preconnect',
      href: 'https://slimages.macysassets.com',
    });
    preconnectLinks.push({
      rel: 'preconnect',
      href: 'https://retailmedia-static.azureedge.net',
    });
    preconnectLinks.push({
      rel: 'preload',
      href: 'https://assets.macysassets.com/common/assets/fonts/macys-sans/MacysSans.woff2',
      as: 'font',
      crossorigin: 'anonymous',
      type: 'font/woff2',
    });
    preconnectLinks.push({
      rel: 'preload',
      href: 'https://assets.macysassets.com/common/assets/fonts/macys-sans/MacysSansMd.woff2',
      as: 'font',
      crossorigin: 'anonymous',
      type: 'font/woff2',
    });
    preconnectLinks.push({
      rel: 'preload',
      href: 'https://assets.macysassets.com/common/assets/fonts/macys-sans/MacysSansBd.woff2',
      as: 'font',
      crossorigin: 'anonymous',
      type: 'font/woff2',
    });
  } else {
    preconnectLinks.push({
      rel: 'preconnect',
      href: 'https://images.bloomingdalesassets.com',
    });
  }

  preconnectLinks.push({
    rel: 'preconnect',
    href: process.env.ASSET_HOST || import.meta.env.ASSET_HOST,
  });
  preconnectLinks.push({
    rel: 'preconnect',
    href: process.env.ASSET_HOST || import.meta.env.ASSET_HOST,
    crossorigin: '',
  });

  return preconnectLinks;
}
